module.exports = __webpack_public_path__ + "static/media/IconTemplates_-35.1dc83891.svg";